export default __webpack_public_path__ + "static/media/NYC-Logo.aed44f0a.png";